import { HttpRequestData, httpUtil } from '@esg/framework';
import { getEnv, GoogleRatingStatus } from '@esg/shared';

export interface ClientReviewCreateRequest extends HttpRequestData {
    readonly pathData: {
        readonly reviewToken?: string;
    };
    body: {
        readonly id?: string;
        readonly rating?: number;
        readonly feedback?: string;
        readonly customerId?: string;
        readonly googleRatingStatus?: GoogleRatingStatus;
        readonly saleId?: string;
        readonly branchId?: string;
    },
}

export interface ClientReviewCreateResponse {
    readonly id?: string;
    readonly rating?: number;
    readonly feedback?: string;
    readonly customerId?: string;
    readonly googleRatingStatus?: GoogleRatingStatus;
    readonly saleId?: string;
    readonly branchId?: string;
}

export const createClientReview = httpUtil.createHttpRequestMeta<
    ClientReviewCreateRequest,
    ClientReviewCreateResponse
>({
    baseUrl: () => getEnv().MANAGEMENT_SERVER,
    method: 'POST',
    path: '/api/v1/reviews/:reviewToken',
});
